import { render, staticRenderFns } from "./ModalEditContact.vue?vue&type=template&id=2772c741&scoped=true&"
import script from "./ModalEditContact.vue?vue&type=script&lang=js&"
export * from "./ModalEditContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditContact.vue?vue&type=style&index=0&id=2772c741&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2772c741",
  null
  
)

export default component.exports